'use client';

import React from 'react';
import { useGlobalClientContext } from '../../common/GlobalClientContext';
import h200Img from '../../../../public/images/h200.png';
import RedirectButton from '../RedirectButton'; 
import { convertNewLinesToBrs } from '@altus-ui/components_v2/utils/text';

export default function Product() {
  const {
    i18nHelper: { t },
  } = useGlobalClientContext();

  const feature1Desc = t('public.site.product.h200.feature1.desc', {});

  return (
    <>
      <div className="flex flex-[1] flex-col items-center gap-3xl mb-9xl">
        <div className="text-5xl leading-18xl text-gray-900 font-semibold whitespace-nowrap">
          {t('public.site.product.h200.feature1', {})}
        </div>
        <div className="text-xl font-regular leading-3xl text-gray-600 text-center w-[800px]">
          {convertNewLinesToBrs(feature1Desc)}
        </div>
        <RedirectButton label={t('public.site.button.reserve.capacity', {})} />
      </div>
      <img src={h200Img.src} alt="H200" />
      <div className="flex flex-row mt-9xl px-[125px] gap-9xl">
        <div className="flex flex-[1] flex-col gap-2xs w-[480px]">
          <div className="text-xl font-semibold leanding-lg text-primary">
            {t('public.site.product.h200.feature2', {})}
          </div>
          <div className="text-md font-regular leading-lg text-secondary">
            {t('public.site.product.h200.feature2.desc', {})}
          </div>
        </div>
        <div className="flex flex-[1] flex-col gap-2xs w-[480px]">
          <div className="text-xl font-semibold leanding-lg text-primary">
            {t('public.site.product.h200.feature3', {})}
          </div>
          <div className="text-md font-regular leading-lg text-secondary">
            {t('public.site.product.h200.feature3.desc', {})}
          </div>
        </div>
      </div>
    </>
  );
}
